import { LumoraClient, LUMORA_PROD_API_BASE_URL, localStorageTokens } from "@lumora/bridge";

const STORAGE_KEY = "lumora.platform.tokens";

export const ADMIN_SITE = "admin";

/** Same fallback as `client.ts` — omit VITE_LUMORA_API in a Pages build must not hit localhost. */
export function resolvePlatformApiBase(api: string | undefined): string {
  const trimmed = api?.trim();
  return trimmed || LUMORA_PROD_API_BASE_URL;
}

/** Platform admin client — same API, admin tenant, persisted tokens. */
export const platformClient = new LumoraClient({
  baseUrl: resolvePlatformApiBase(import.meta.env.VITE_LUMORA_API),
  ...localStorageTokens(STORAGE_KEY),
  onUnauthorized: () => {
    if (typeof window !== "undefined") {
      window.location.hash = "#/platform/signin";
    }
  },
});

export function isPlatformAdmin(): boolean {
  return platformClient.claims()?.role === "admin";
}

export function signOutPlatform(): void {
  platformClient.logout();
}
